import "./ChatList.scss";

import React, { useEffect, useState } from "react";
import {MdDelete, MdEdit} from "react-icons/md";
import {Link, useNavigate} from "react-router-dom";

import SideBar from "../../../components/SideBar/SideBar";
import TableColumn from "../../../components/TableColumn/TableColumn";
import TopNav from "../../../components/TopNav/TopNav";
import api from "../../../services/api";
import Button from "../../../components/Buttons/Button";
import {format} from "date-fns";
import Modal from "react-bootstrap/Modal";
import {toast} from "react-toastify";

function ChatList() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [chats, setChats] = useState([]);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        Number(localStorage.getItem("ListCurrentPageChats")) || 1
    );
    const records = 10;

    const [searchTerm, setSearchTerm] = useState("");

    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState("null");
    const [showSuccess, setShowSuccess] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);


    const actions = [
        {
            label: <MdDelete size={30} color="red" />,
            onClick: (rowData) => {
                const confirmDelete = window.confirm("Are you sure you want to delete this item?");
                if (confirmDelete) {
                    handleDelete(rowData);
                }
            },
        },
    ];

    const handleDelete = async (rowData) => {
        if (loadingDelete) return;
        setLoadingDelete(true);

        const url = `/chat/admin/${rowData._id}`;

        try {
            await api.delete(url);
            await getChats(currentPage);
            toast.success("Chat deleted successfully.");
        } catch (error) {
            console.error("Error deleting item:", error);
            alert("There was an error deleting the item. Please try again. " + error?.message);
        } finally {
            setLoadingDelete(false);
        }
    };


    const getChats = async (page) => {
        try {
            const url = `/chat/search?name=${searchTerm}`;
            const response = await api.get(url, {
                params: {
                    records: records,
                    page: page,
                    sort_column: sortBy,
                    sort: sortDirection,
                },
            });
            const formattedChats = response.data.data.map(chat => ({
                '_id': chat._id,
                Name: chat.name,
                'Chat Type': chat.chatType,
                Participants: (
                    <Link to={`/participants/${chat?._id}`} className="number-pill">
                        {chat.participants.length}
                    </Link>
                ),
                Admin: chat.adminName,
                'Chat Expiry Date': chat.chat_expiry_date ? format(chat.chat_expiry_date, "MMMM dd, yyyy") : '--',
            }));

            setChats(formattedChats);
            setTotalPages(response.data.total);
        } catch (error) {
            console.log(`venues get request didn't work. error: ${error}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getChats(currentPage);
    }, [navigate, currentPage, sortBy, sortDirection, searchTerm]);




    const fetchAllData = async () => {
        try {
            const url = `/chat/search?name=${searchTerm}`;
            const response = await api.get(url, {
                params: {
                    records: records,
                    page: 1000000000,
                    sort_column: sortBy,
                    sort: sortDirection,
                },
            });
            return response.data.data.map(chat => ({
                '_id': chat._id,
                Name: chat.name,
                'Chat Type': chat.chatType,
                Participants: <Link
                    to={`/participants/${chat?._id}`}
                    className="number-pill"
                >
                    {chat.participants.length}
                </Link>,
                Admin: chat.admin,
                'Chat Expiry Date': chat.chat_expiry_date,
            }));
        } catch (error) {
            console.log(`Error fetching all data: ${error}`);
            return [];
        }
    };


    const columns = [
        "Name",
        "Chat Type",
        "Participants",
        "Admin",
        "Chat Expiry Date"
    ];

    const sortableColumns = ["Name"];


    const handleChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        setCurrentPage(0);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem("ListCurrentPageChats", page);
    };



    useEffect(() => {
        const storedPage = localStorage.getItem("ListCurrentPageChats");

        setCurrentPage(Number(storedPage) || 1);
    }, []);


    const sortColumnsMapping = {
        Name: "name",
    };

    const handleSort = (columnName) => {
        const backendColumnName = sortColumnsMapping[columnName];
        if (sortBy === backendColumnName) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(backendColumnName);
            setSortDirection("asc");
        }
    };

    const SuccessModal = () => (
        <Modal show={showSuccess} onHide={() => setShowSuccess(false)} centered>
            <div
                style={{
                    backgroundColor: '#1c1c1c',
                    color: '#fff',
                    borderRadius: '10px',
                    padding: '1rem',
                    width: '100%',
                }}
            >
                <Modal.Body
                    style={{
                        backgroundColor: '#1c1c1c',
                        color: '#fff',
                        borderRadius: '10px',
                        padding: '1.5rem',
                    }}
                >
                    <div className="text-center">
                        <h1 className="mb-3 fs-20">Success</h1>
                        <p className="mb-4">Chat deleted successfully.</p>
                    </div>
                </Modal.Body>
            </div>
        </Modal>
    );

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <SuccessModal />
                <article className="page-content">
                    <section className="venues">
                        <TableColumn
                            title="Chats"
                            columns={columns}
                            data={chats}
                            sortableColumns={sortableColumns}
                            hasExport={true}
                            hasSearch={true}
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            records={records}
                            actions={actions}
                            customButton={
                                <Button
                                    label="Add new chat +"
                                    onClick={() => navigate("/create-chat")}
                                    primaryBtn
                                    style={{ paddingBottom: "18px", paddingTop: "18px" }}
                                />
                            }
                            inputSearchProps={{ value: searchTerm, onChange: handleChange }}
                            fetchAllData={fetchAllData}


                            onSort={handleSort}

                        />
                    </section>
                </article>
            </div>
        </main>
    );
}

export default ChatList;
